// extracted by mini-css-extract-plugin
export default {"surchargeModal":"surcharge-modal__surchargeModal__gWAMC","surchargeModalBody":"surcharge-modal__surchargeModalBody__Sj9BH"};